<template>
  <div class="merchant-selector">
    <el-input
      :value="selectedMerchantName"
      placeholder="请选择商户"
      :readonly="true"
      @mouseenter.native="hovering = true"
      @mouseleave.native="hovering = false"
    >
      <template slot="suffix">
        <i
          v-show="selectedMerchantName && hovering"
          class="el-input__icon el-icon-circle-close"
          @click="handleClear"
          style="cursor: pointer;"
        ></i>
      </template>
      <template slot="append">
        <el-button
          icon="el-icon-more-outline"
          @click="openDialog"
          class="select-button"
        >
        </el-button>
      </template>
    </el-input>

    <el-dialog
      title="选择商户"
      :visible.sync="dialogVisible"
      width="70%"
      :before-close="handleDialogClose"
      :modal-append-to-body="true"
      :append-to-body="true"
      custom-class="merchant-dialog"
    >
      <div class="search-area">
        <el-select
          v-model="appId"
          placeholder="请选择应用"
          clearable
          style="width: 200px;"
          @change="handleAppChange"
        >
          <el-option
            v-for="item in appList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-input
          v-model="keyword"
          placeholder="请输入商户名称搜索"
          clearable
          style="width: 300px;"
          @clear="handleSearchClear"
          @keyup.enter.native="handleSearch"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜 索</el-button>
      </div>

      <el-table
        :data="merchantList"
        :height="tableHeight"
        size="small"
        border
        style="width: 100%; margin-top: 10px;"
        highlight-current-row
        @row-click="handleRowClick"
        @row-dblclick="handleRowDblClick"
        ref="merchantTable"
      >
        <el-table-column prop="id" label="ID" width="200"></el-table-column>
        <el-table-column
          prop="name"
          label="商户名称"
          sortable
          :sort-method="sortByName"
        ></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="200" sortable></el-table-column>
      </el-table>

      <el-pagination
        style="margin-top: 10px; float: right;"
        background
        layout="prev, pager, next"
        :current-page.sync="page"
        :page-size.sync="rows"
        :total="tableTotal"
        @current-change="currentPageChanged"
      >
      </el-pagination>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirm" :disabled="!selectedMerchant">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import httpClient from '../httpClient.js'

export default {
  name: "MerchantSelector",
  props: {
    value: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      keyword: '',
      page: 1,
      rows: 20,
      tableTotal: 0,
      merchantList: [],
      appList: [],
      appId: null,
      tableHeight: 400,
      selectedMerchant: null,
      selectedMerchantName: '',
      hovering: false
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.loadMerchantName(newVal)
        } else {
          this.selectedMerchantName = ''
          this.selectedMerchant = null
        }
      }
    }
  },
  methods: {
    queryList() {
      let data = {
        page: this.page,
        rows: this.rows,
        params: {
          keyword: this.keyword,
          appId: this.appId
        }
      }
      httpClient.post("/api/merchant/query", data).then((response) => {
        this.tableTotal = response.data.data.total
        this.merchantList = response.data.data.list
      })
    },
    queryAllAppList() {
      httpClient.post("/api/app/query", {}).then((response) => {
        this.appList = response.data.data.list
      })
    },
    calcTableHeight() {
      // 按视口高度计算固定表格高度，避免数据行数变化导致弹框高度跳动
      this.tableHeight = Math.max(300, Math.floor(window.innerHeight * 0.5))
    },
    handleAppChange() {
      this.page = 1
      this.queryList()
    },
    currentPageChanged() {
      this.queryList()
    },
    handleSearch() {
      this.page = 1
      this.queryList()
    },
    handleSearchClear() {
      this.keyword = ''
      this.page = 1
      this.queryList()
    },
    handleRowClick(row) {
      this.$refs.merchantTable.setCurrentRow(row)
      this.selectedMerchant = row
    },
    handleRowDblClick(row) {
      this.selectedMerchant = row
      this.handleConfirm()
    },
    handleConfirm() {
      if (this.selectedMerchant) {
        this.selectedMerchantName = this.selectedMerchant.name
        this.$emit('input', this.selectedMerchant.id)
        this.$emit('change', this.selectedMerchant)
        this.dialogVisible = false
      }
    },
    handleDialogClose() {
      this.dialogVisible = false
    },
    handleClear() {
      this.selectedMerchantName = ''
      this.selectedMerchant = null
      this.$emit('input', null)
      this.$emit('change', null)
    },
    handleMouseEnter() {
      this.hovering = true
    },
    openDialog() {
      this.dialogVisible = true
      this.queryList()
    },
    loadMerchantName(merchantId) {
      httpClient.get(`/api/merchant/${merchantId}`).then((response) => {
        if (response.data.data) {
          this.selectedMerchantName = response.data.data.name
        }
      }).catch(() => {
        this.selectedMerchantName = ''
      })
    },
    sortByName(a, b) {
      return a.name.localeCompare(b.name, 'zh-CN')
    }
  },
  mounted() {
    this.queryAllAppList()
    this.calcTableHeight()
    window.addEventListener('resize', this.calcTableHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calcTableHeight)
  }
};
</script>

<style scoped>
.merchant-selector {
  display: inline-block;
  width: 100%;
}

.select-button {
  border-left: none;
  border-radius: 0;
}

.search-area {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
</style>

<style>
.merchant-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}

.merchant-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}
</style>
